import { forwardRef } from "react";
import PropTypes from "prop-types";
import classes from "./InputTop.module.scss";
import { Fill } from "@educaplay/core/components";
import { useTranslate } from "@educaplay/core";

import { useSelector } from "react-redux";
import { useClickAway } from "@educaplay/core/hooks/useClickAway";
import { NextSubmitButton } from "@educaplay/core/components";

const InputTop = forwardRef(function InputTop(props, ref) {
    const { onBlur, handleSubmit, onFocus, onChange, isInputEmpty, composeRef, isStartLetter, currentChar, heightBall } = props;
    const t = useTranslate();
    const showBank = useSelector(state => {
        return !!(state.game.questions[state.game.currentIndex].bank)
    })

    const formRef = useClickAway(
        () => {
                onBlur();
        }
    )

    const inputHandler = (event) => {
        const word = event.target.value.trim();
        onChange(word)
    }

    const Focushandler = () => {
            ref.current.focus();
    }
    
    return (
        <Fill name="InputTop">
            <div className={classes.compose} ref={composeRef} style={{transform: 'translateY('+(showBank? 0 : -6)+'vh)' }}>
               <div className={classes.formContainer} ref={formRef}>
                    <form onSubmit={handleSubmit}>
                        <input className={classes.input} type="text" ref={ref} onChange={inputHandler} onFocus={onFocus} />
                        <NextSubmitButton showSubmit={!isInputEmpty} className={classes.button} onFocus={Focushandler} />
                    </form>
                </div>
                <div className={classes.inputTitle} style={{fontSize: 'min( 22px , ' + ((heightBall / 5) * 50) / 100 + 'px )' }}>{isStartLetter ? t('specific.beginsWith') : t('specific.contains')} <span className={classes['inputTitle__character']}>{currentChar}</span></div>
                
            </div>
        </Fill>

    )
})




export default InputTop;

InputTop.propTypes = {
    onBlur: PropTypes.func
}